<template>
    <list-page icone="mdi-account-tie" titulo="Fornecedor" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:corpo>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

            </template>

          </v-data-table>

          <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td class="justify-center layout px-0">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                    <td>{{ item.cpfCnpj }}</td>
                    <td>{{ item.nome }}</td>
                    <td>{{ item.telefone }}</td>
                    <td>{{ item.celular }}</td>
                    <td>{{ item.email }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table> -->

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-fornecedor v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

        </template>
    </list-page>
</template>
<script>
import FornecedorService from '@/core/services/financeiro/FornecedorService';
import Fornecedor from '@/core/domain/financeiro/Fornecedor';
import ListPage from "@/components/shared/ListPage";

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value:'actions', sortable: false  },
        { text: '#', value: 'id', type:'number' },
        { text: 'CPF/CNPJ', value: 'cpfCnpj' },
        { text: 'Nome', value: 'nome' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Celular', value: 'celular' },
        { text: 'E-mail', value: 'email' },
      ],
      primeiraCarga: true
    }),
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    created() {
      this.service = new FornecedorService();
    },
    methods: {
      Novo(){
        this.NovoCadastro(new Fornecedor());
      },
      Editar(item){
        this.service.ObterPorId(item.id)
          .then(
            res =>{
              this.EditarCadastro(new Fornecedor(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      }
    },
    mounted() {
      this.Listar()
    }
}
</script>
<style scoped>

</style>
